import { TaskDocumentData } from "./task-documents";
import { ActionListItemModel } from "@genexus/chameleon-controls-library/dist/types/components/action-list/types";
import { ComboBoxItemModel } from "@genexus/chameleon-controls-library/dist/types/components/combo-box/types";

export const taskDocumentsToActionListItemModel = (
  objects: TaskDocumentData[],
  selectedDocument?: TaskDocumentData
): ActionListItemModel[] => {
  const actionListDocuments: ActionListItemModel[] = [];
  objects?.forEach((object, index) => {
    const itemId = `task-${object.name}`;
    const itemValue = object.name;
    actionListDocuments.push({
      id: itemId,
      caption: itemValue,
      selected: selectedDocument
        ? selectedDocument.name === object.name
        : index === 0,
      type: "actionable"
    });
  });
  return actionListDocuments;
};

/* References Types*/

/**
 * @description This function converts string[] to ComboBoxItemModel[]
 */
export const convertSuggestedDocumentsToSuggestItems = (
  suggestedDocuments: string[]
): ComboBoxItemModel[] => {
  const suggestItems: ComboBoxItemModel[] = [];
  if (suggestedDocuments.length) {
    suggestedDocuments.forEach((suggestedDocument: string) => {
      const suggestItem: ComboBoxItemModel = {
        value: suggestedDocument,
        caption: suggestedDocument
      };
      suggestItems.push(suggestItem);
    });
  }
  return suggestItems;
};
